import styles from './RealName.module.css';

const RealName = ({ name }) => {
  return <span className={styles.name}>{name}</span>;
};

export default RealName;
